module.exports = __webpack_public_path__ + "img/D20151225_1.8fcfdbcd.gif";